
const Header = () => {

    const bgMobile = process.env.PUBLIC_URL + '/images/bg-header-mobile.svg';
    const bgDesktop = process.env.PUBLIC_URL + '/images/bg-header-desktop.svg';

    return (
        <header>
            <picture>
                <source media="(min-width: 768px)" srcSet={bgDesktop} />
                <img src={bgMobile} alt="" className='w-full bg-desaturated-dark-cyan' />
            </picture>
        </header>
    );
}
 
export default Header;